<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="img/brand/logo-amo.png" alt="logo" height="50px">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                  <img src="img/brand/logo-amo.png">
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.facebook.com/AuxilioMaternidadeOfic/" target="_blank" rel="noopener"
                       data-toggle="tooltip" title="Acessar Facebook">
                        <i class="fa fa-facebook-square icon-header"></i>
                        <span class="nav-link-inner--text d-lg-none">Facebook</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.instagram.com/auxiliomaternidadeoficial/"
                       target="_blank" rel="noopener" data-toggle="tooltip" title="Acessar Instagram">
                        <i class="fa fa-instagram icon-header"></i>
                        <span class="nav-link-inner--text d-lg-none">Instagram</span>
                    </a>
                </li>
              <li class="nav-item">
                <a class="nav-link nav-link-icon" href="https://www.youtube.com/channel/UCw1RMbFJ6d9Ez4LtV1xgE8A"
                   target="_blank" rel="noopener" data-toggle="tooltip" title="Acessar Youtube">
                  <i class="fa fa-youtube icon-header"></i>
                  <span class="nav-link-inner--text d-lg-none">Youtube</span>
                </a>
              </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://auxiliomaternidadeoficial.com.br"
                       target="_blank" rel="noopener" data-toggle="tooltip" title="Acessar Site">
                        <i class="fa fa-globe icon-header"></i>
                        <span class="nav-link-inner--text d-lg-none">Site Amo</span>
                    </a>
                </li>
                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a onclick="handleButton()" class="btn_whats">
                        <i class="fa fa-whatsapp mr-2"></i>
                        <span class="nav-link-inner--text">WhatsApp</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from '@/components/BaseNav'
import CloseButton from '@/components/CloseButton'
import config from '../../config'

export default {
  components: {
    BaseNav,
    CloseButton
  },
  data: () => ({
    url: config.links.whatsapp
  })
}
</script>
<style>
</style>
